import type {
  PathLookupGraphPreset,
  TopologyGraphPreset,
} from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';
import { getPresetFunctionByMode } from 'components/Graph/commands/helpers/getPresetFunctionByMode';

export const selectAppliedPreset = (
  s: GraphState,
): TopologyGraphPreset | PathLookupGraphPreset | undefined =>
  s.graphMetadata
    ? getPresetFunctionByMode[s.graphMetadata.parameters.type](s)
    : undefined;
